import { ClickEvent, DataDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { LogicBrokeragePlanningPerformance } from "./LogicBrokeragePlanningPerformance";
import { AutogenLayoutBrokeragePlanningPerformanceRevenue } from "./autogen/AutogenLayoutBrokeragePlanningPerformanceRevenue";
import { BrokeragePlanningPerformance } from "./widgets/BrokeragePlanningPerformance";

export class BrokeragePlanningPerformanceRevenue extends AutogenLayoutBrokeragePlanningPerformanceRevenue {
    public perfHeaderRow: ModelRow;
    private brokeragePlanningPerformance: BrokeragePlanningPerformance;

    onLoad() {
        this.chartRevenue.renderDefaultData = false;
        this.brokeragePlanningPerformance = this.owner as BrokeragePlanningPerformance;
    }

    /** This is an event handler for the onDisplay event of sourceBPPerfRevenue.  */
    sourceBPPerfRevenueOnDisplay(event: DataDisplayEvent) {
        LogicBrokeragePlanningPerformance.setTableColumnHeaders(this.tableBPPerfRevenue, this.perfHeaderRow);
        const brokerageStatusesToChart = ["Available", "Covered", "In Progress", "Delivered", "Total"];
        LogicBrokeragePlanningPerformance.createChartData(this.tableBPPerfRevenue, this.chartRevenue, this.mainDataSource.data, this.perfHeaderRow, brokerageStatusesToChart);
        this.chartRevenue.renderChart();
    }

    cellLabelOnClick(event: ClickEvent) {
        LogicBrokeragePlanningPerformance.cellLabelOnClick(event, this.perfHeaderRow, this.brokeragePlanningPerformance.currentProfile);
    }
}
